import { IEnvironment } from './ienvironment';

// Nuvem
export const environment: IEnvironment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyDbmmC-X2yEP-tY_Vw9kmaHeUYf3slngOk',
    authDomain: 'cpqdcloud-dev.firebaseapp.com',
  },
  BACKEND_HOST: window.location.origin,
  QGIS_PATH:
    'https://datasafra-backend-api-gateway-3tfjxbph.uc.gateway.dev/qgis',
  MARTIN_HOST: 'datasafra-mvt-server-299159640197.us-central1.run.app',
  MARTIN_PROTOCOL: 'https',
  GOOGLE_API_KEY: 'AIzaSyBv1EnfJx_evfBwqfAIjKawyraooGlkCfs', //datasafra
  CONTACT_URL: 'https://conteudo.geoambiente.com.br/pre-lancamento-datasafra',
  agentRuntimeUrl: window.location.origin + '/agent',
};
